var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 337.36 50.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a37b50;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "surprised"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 61.81,
    cy: 25.52,
    rx: 62.59,
    ry: 19.39,
    transform: "translate(-3.37 10.58) rotate(-9.52)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 276.92,
    cy: 25.3,
    rx: 19.39,
    ry: 62.59,
    transform: "translate(176.98 284.79) rotate(-74.16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset1);
export default __webpack_public_path__ + "static/media/Asset 1.90534500.svg";
export { ForwardRef as ReactComponent };